import { useQuery } from 'react-query';
import API from '../api/phx';

/** Function to add some default config settings to each query */
const getDefaultConfig = (config) => {
  let queryConfig = config;


  return queryConfig;
};

const fetchContentData = async () => {
  const res = await API.get(`/content`);
  return res.data;
};

export const useContent = (config) => {
  const queryConfig = getDefaultConfig(config);
  return useQuery(['content'], fetchContentData, queryConfig);
};


export default useContent;